import React, { PropsWithChildren } from 'react';

import FacebookIcon from '../../assets/svg-components/fb_icon.svg';
import InstagramIcon from '../../assets/svg-components/insta_icon.svg';
import TiktokIcon from '../../assets/svg-components/tiktok_icon.svg';
import TwitterIcon from '../../assets/svg-components/tw_icon.svg';
import YoutubeIcon from '../../assets/svg-components/youtube_icon.svg';
import { cn } from '../../utils/classname';
import './icon-button.scss';

type NativeSVGProps = JSX.IntrinsicElements['svg'];

interface IconButtonProps extends PropsWithChildren<NativeSVGProps> {
  href: string;
  name: 'twitter' | 'facebook' | 'instagram' | 'youtube' | 'tiktok';
  className?: string;
}

const IconButton: React.FC<IconButtonProps> = ({ href, name, className, ...svgProps }) => {
  let Icon = null;
  const classes = cn('bd-icon-button', className);

  switch (name) {
    case 'twitter':
      Icon = TwitterIcon;
      break;
    case 'facebook':
      Icon = FacebookIcon;
      break;
    case 'instagram':
      Icon = InstagramIcon;
      break;
    case 'youtube':
      Icon = YoutubeIcon;
      break;
    case 'tiktok':
      Icon = TiktokIcon;
      break;
  }
  return (
    <a rel="noreferrer" target="_blank" href={href} className={classes} data-component="icon-button">
      <Icon {...svgProps} />
    </a>
  );
};

export default IconButton;
